export const getEventBg = (eventType?: string, forAllDay = false, customColor?: string | null) => {
  if (customColor) {
    if (forAllDay) return customColor;
    const hex = customColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, 0.15)`;
  }

  // All-day/multi-day events use white text, so backgrounds must be dark/opaque
  if (eventType === 'flight') return forAllDay ? 'rgb(var(--color-primary-rgb))' : 'rgba(var(--color-primary-rgb), 0.18)';
  if (eventType === 'hotel') return forAllDay ? '#b45309' : 'var(--color-warning-muted)';
  if (eventType === 'meeting') return forAllDay ? '#15803d' : 'var(--color-success-muted)';
  if (eventType === 'birthday') return forAllDay ? '#be185d' : '#fce7f3';
  if (eventType === 'restaurant') return forAllDay ? '#c2410c' : '#ffedd5';
  if (eventType === 'train') return forAllDay ? '#0ea5e9' : '#e0f2fe';
  if (eventType === 'call') return forAllDay ? '#1d4ed8' : '#dbeafe';

  // Default color for Xavior-created events or events with no resolved color.
  return forAllDay ? '#4285F4' : 'rgba(66, 133, 244, 0.22)';
};

export const getEventDotColor = (eventType?: string, providerCalendarId?: string, customColor?: string | null) => {
  if (customColor) return customColor;

  if (!providerCalendarId) {
    return '#64748b';
  }

  switch (eventType) {
    case 'meeting': return '#4338ca';
    case 'flight': return '#0284c7';
    case 'hotel': return '#7c3aed';
    case 'restaurant': return '#ea580c';
    case 'activity': return '#059669';
    case 'birthday': return '#db2777';
    default: return '#64748b';
  }
};
